import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../common/constants/routes';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Brand from '../../../assets/svg/brand.svg?react';
import { primaryColor } from '../../common/theme/theme';

const PageNotFound = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ padding: 3 }}>
      <Box
        className='svg-wrapper'
        style={{ color: primaryColor }}
        sx={{ textAlign: 'center', marginBottom: 3 }}
      >
        <Brand />
      </Box>
      <Box
        component='h1'
        sx={{ marginBottom: 3, textAlign: 'center', fontSize: { xs: '1.5rem', sm: '2rem' } }}
      >
        {t('pageNotFoundHeader')}
      </Box>
      <Box component='p' sx={{ marginBottom: 3, textAlign: 'center' }}>
        {t('pageNotFoundMessage')}
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Button
          id='pageNotFoundGoHomeLinkBtn'
          component={RouterLink}
          variant='contained'
          size='medium'
          to={ROUTES.INDEX}
        >
          {t('goHomeLink')}
        </Button>
      </Box>
    </Box>
  );
};

export default PageNotFound;
